import { useEffect, useState } from "react";
import { DownloadSimple, MagnifyingGlass } from "@phosphor-icons/react";
import { adminApi, detail, fmtDate, expiresText, STATUS, PLAN, METHOD } from "@/lib/adminApi";
import { DeviceCard } from "@/components/admin/DeviceCard";

const CHIPS = [
  { id: "all", label: "Svi", params: {} },
  { id: "today", label: "Danas", params: { new_today: "true" } },
  { id: "trial", label: "Proba", params: { status: "trial" } },
  { id: "active", label: "Aktivni", params: { status: "active" } },
  { id: "expired", label: "Istekli", params: { status: "expired" } },
  { id: "paid", label: "Plaćeni", params: { paid: "true" } },
  { id: "yearly", label: "Godišnji", params: { paid: "yearly" } },
  { id: "lifetime", label: "Doživotni", params: { paid: "lifetime" } },
  { id: "blocked", label: "Blokirani", params: { status: "blocked" } },
];

const exportCsv = (rows) => {
  const cols = [
    ["Device Key", (d) => d.device_key], ["MAC", (d) => d.mac], ["Status", (d) => STATUS[d.status]?.label || d.status],
    ["Plan", (d) => PLAN[d.plan] || d.plan || ""], ["Ističe", expiresText], ["Plaćeno", (d) => (d.paid ? d.paid_amount : "")],
    ["Email", (d) => d.email || ""], ["Telefon", (d) => d.phone || ""], ["Način", (d) => METHOD[d.payment_method] || ""], ["Kreiran", (d) => fmtDate(d.created_at)],
    ["Poslednja aktivnost", (d) => fmtDate(d.last_seen)],
  ];
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [cols.map((c) => esc(c[0])).join(","), ...rows.map((d) => cols.map((c) => esc(c[1](d))).join(","))].join("\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" }));
  a.download = `uredjaji-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
};

export const Devices = ({ refreshKey, askConfirm, runAction }) => {
  const [q, setQ] = useState("");
  const [search, setSearch] = useState("");
  const [chip, setChip] = useState("all");
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const params = { ...CHIPS.find((c) => c.id === chip).params };
    if (search) params.q = search;
    setRows(null); setError("");
    adminApi.get("/admin/devices", { params }).then((r) => setRows(r.data)).catch((e) => { setError(detail(e)); setRows([]); });
  }, [chip, search, refreshKey]);

  return (
    <div className="flex flex-col gap-4" data-testid="devices-screen">
      <div className="flex flex-col gap-3 md:flex-row">
        <form onSubmit={(e) => { e.preventDefault(); setSearch(q.trim()); }} className="flex flex-1 gap-2">
          <input className="input flex-1" placeholder="Device Key, MAC, email ili telefon" value={q} onChange={(e) => setQ(e.target.value)} data-testid="devices-search-input" />
          <button type="submit" className="btn-primary px-4" data-testid="devices-search-btn"><MagnifyingGlass size={18} weight="bold" /></button>
        </form>
        <button onClick={() => exportCsv(rows || [])} disabled={!rows?.length} className="btn-ghost disabled:opacity-40" data-testid="export-csv-btn"><DownloadSimple size={18} /> Izvoz CSV</button>
      </div>
      <div className="flex flex-wrap gap-2" data-testid="device-filter-chips">
        {CHIPS.map((c) => (
          <button key={c.id} onClick={() => setChip(c.id)} data-testid={`chip-${c.id}`}
            className={`rounded-full border px-3.5 py-1.5 text-xs font-semibold transition-colors ${chip === c.id ? "border-brand bg-brand text-white" : "border-lineStrong text-txt2 hover:text-white"}`}>{c.label}</button>
        ))}
      </div>
      {error && <p className="text-sm text-err">{error}</p>}
      {rows === null ? <p className="text-muted2">Učitavanje…</p> : (
        <>
          <p className="text-xs text-muted2" data-testid="devices-count">{rows.length} uređaja</p>
          <div className="flex flex-col gap-3">
            {rows.map((d) => <DeviceCard key={d.device_id} d={d} askConfirm={askConfirm} runAction={runAction} />)}
          </div>
        </>
      )}
    </div>
  );
};
